export default __webpack_public_path__ + "static/media/exgcoin_new.358acb79.png";